import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { createDevice, getDevices } from '../../api/devices';
import { onDevicesChanged } from '../../api/billingHooks';

interface DeviceFormProps {
  initialData?: any;
  propertyId?: number | string;
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
}

export const DeviceForm: React.FC<DeviceFormProps> = ({ initialData, propertyId, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState(initialData || {});
  const [loading, setLoading] = useState(false);
  const set = (key: string, val: string) => setFormData((p: any) => ({ ...p, [key]: val }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!initialData) {
        const propId = propertyId || formData.property_id;
        const created = await createDevice({
          name: formData.name,
          type: formData.type || 'intercom',
          model: formData.model,
          serial_number: formData.serial_number,
          property_id: propId,
        });
        // Update subscription device count
        if (propId) {
          getDevices({ property_id: propId }).then((devices: any) => {
            const count = Array.isArray(devices) ? devices.length : (devices?.items?.length || 0);
            onDevicesChanged(propId, count).catch(() => {});
          }).catch(() => {});
        }
        await onSubmit(created);
      } else {
        await onSubmit(formData);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input label="Name" value={formData.name || ''} onChange={(e) => set('name', e.target.value)} required />
      <Input label="Type" value={formData.type || ''} onChange={(e) => set('type', e.target.value)} />
      <Input label="Model" value={formData.model || ''} onChange={(e) => set('model', e.target.value)} />
      <Input label="Serial Number" value={formData.serial_number || ''} onChange={(e) => set('serial_number', e.target.value)} />
      <div className="flex gap-3 justify-end mt-6">
        <Button variant="secondary" type="button" onClick={onCancel}>Cancel</Button>
        <Button type="submit" loading={loading}>{initialData ? 'Update' : 'Create'} Device</Button>
      </div>
    </form>
  );
};
